module.exports = __webpack_public_path__ + "static/img/5.971cd95e.png";